<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Menu from "@components/layout/Menu.svelte";
	import closeIcon from "@core/assets/icons/close.svg?raw";
	import commarecLogo from "@core/assets/images/logo.svg?raw";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import NotificationBanner from "../NotificationBanner.svelte";
	import AlgoliaSearchbar from "./AlgoliaSearchbar.svelte";
	import LanguageSwitcher from "./LanguageSwitcher.svelte";

	const { tenant, notifications } = getGlobalTemplateProps();

	let searchbarOpen = $state(false);
	let mobileMenuOpen = $state(false);
	let searchText = $state("");
</script>

<NotificationBanner {notifications} />
<div class={[["w-full top-0 z-40", mobileMenuOpen ? "fixed" : "sticky"]]}>
	<header
		class={[
			"flex items-center justify-between h-12 xl:h-20 px-6 xl:px-2 min-[1285px]:px-6 ",
			mobileMenuOpen ? "bg-white" : "bg-cmcbg/50 backdrop-blur-xl xl:has-[nav:hover]:bg-white",
		]}
	>
		<!-- Header -->
		<a href={getHomepagePath(tenant)} aria-label="Commarec" class={[searchbarOpen && "xl:order-1"]}>
			<Icon icon={commarecLogo} class="h-6 xl:h-8 aspect-[4.5]" />
		</a>
		<Menu bind:mobileOpen={mobileMenuOpen} bind:searchOpen={searchbarOpen} bind:searchText />
		<div
			class={["hidden xl:flex gap-2 2xl:gap-6 items-center", searchbarOpen && "xl:justify-between xl:order-2 xl:grow"]}
		>
			<div></div>
			<div class="flex gap-8 relative mx-auto">
				<AlgoliaSearchbar bind:searchText bind:open={searchbarOpen} />
				{#if searchbarOpen}
					<Button
						onclick={(): void => {
							searchText = "";
							searchbarOpen = false;
						}}
						variant={ButtonVariant.Text}
						class="text-cmcwarning !gap-1"
					>
						<span class="uppercase text-xs tracking-[0.002em]">Zavřít</span>
						{#snippet icon()}
							<Icon icon={closeIcon} class="size-6" />
						{/snippet}
					</Button>
				{/if}
			</div>
			<LanguageSwitcher />
		</div>
	</header>
</div>
